// NOTE: Role Types are equivalent to Genesys Cloud Permissions Roles
export enum RoleType {
  DEVELOPER = 'Developer',
  ARCHITECT = 'Architect', // custom role not part of GC
  SYSTEM_ADMINISTRATOR = 'System Administrator', // custom role not part of GC
  OUTBOUND_ADMIN = 'Outbound Admin',
  ADMIN = 'Admin',
  ADMINISTRATOR = 'Administrator',
  MASTER_ADMIN = 'Master Admin',
  COMMUNICATE_ADMIN = 'Communicate - Admin',
  GENESYS_CLOUD_VOICE_ADMIN = 'Genesys Cloud Voice Admin',
  TELEPHONY_ADMIN = 'Telephony Admin',
  WEM_QUALITY_ADMIN = 'Quality Admin', // DEPRECATE: Not a default Genesys Cloud Role
  WEM_QUALITY_ADMINISTRATOR = 'Quality Administrator',
  WEM_PERFORMANCE_MANAGEMENT_ADMIN = 'Performance Management Admin',
  WEM_PLANNER_ADMIN = 'Planner Admin',
  WEM_PLANNING_ADMIN = 'Planning Admin', // DEPRECATE: Not a default Genesys Cloud Role. See Planner admin
  SUPERVISOR = 'Supervisor',
  AGENT = 'Agent',
  EMPLOYEE = 'Employee',
  UNKNOWN = 'Unknown',
}

/**
 * Role Priority Rank by Fibonnaci sequence (0,1,1,2,3,5,8,13,21,34,55,89,144,233 etc..)
 * Lowest priority rank is -1 to N, where N is the highest priorit rank
 */
export enum RoleTypePriorityRank {
  WEM_QUALITY_ADMIN = 34, // custom role not part of GC
  WEM_QUALITY_ADMINISTRATOR = 34, // custom role not part of GC
  WEM_PERFORMANCE_MANAGEMENT_ADMIN = 34, // custom role not part of GC
  WEM_PLANNER_ADMIN = 34, // custom role not part of GC
  WEM_PLANNING_ADMIN = 34, // custom role not part of GC
  MASTER_ADMIN = 34, // default role from GC
  SUPERVISOR = 34, // default role from GC
  OUTBOUND_ADMIN = 21, // default role from GC
  COMMUNICATE_ADMIN = 13, // default role from GC
  GENESYS_CLOUD_VOICE_ADMIN = 13, // default role from GC
  TELEPHONY_ADMIN = 13, // default role from GC
  ARCHITECT = 8, // custom role not part of GC
  SYSTEM_ADMINISTRATOR = 8, // custom role not part of GC
  ADMIN = 5, // default role from GC
  ADMINISTRATOR = 5, // default role from GC
  DEVELOPER = 0, // default role from GC
  EMPLOYEE = -1, // default role from GC
  AGENT = -1,
  UNKNOWN = -1,
}
